import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import { warningsAfterPageQuestionRemove } from '../../../utils/SurveyChangeWarnings'
import SurveyUpdateWarnings from '../../SurveyUpdateWarnings'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import { trackBuilderQuestionMenuAction } from '../../../utils/MixpanelManager'

@observer
export default class QuestionDelete extends Component {
    close = () => {
        const { store } = this.props
        store.questionToDelete = {}
        store.questionDeleteConfirm = false
    }

    removeQuestion = () => {
        const { store } = this.props
        const { question } = store.questionToDelete
        const { page } = store.questionToDelete
        const { question_id } = store.questionToDelete
        store.questionToDelete = {}
        trackBuilderQuestionMenuAction(store, { action: 'delete question' })
        page.removeQuestion({
            store,
            question,
            index: question_id,
        })
        if (question.question.metadata.oid < 6) store.refreshSurveyQList()
        store.questionDeleteConfirm = false
    }

    getSkipLogicChanges = () => {
        const { store } = this.props
        const { survey, questionToDelete } = store
        const question = R.pathOr(null, ['question'], questionToDelete)
        return (question && process.env.USE_NEW_SURVEY_WARNINGS)
            ? warningsAfterPageQuestionRemove(survey, question, store)
            : {
                isSkipLogicAffected: false,
                isInheritanceAffected: false,
            }
    }

    renderSkipLogicWarnings = () => {
        const warnings = this.getSkipLogicChanges()

        return <SurveyUpdateWarnings warnings={warnings} />
    }

    render() {
        const { store } = this.props
        return (
            <Modal
                show={store.questionDeleteConfirm}
                onClose={this.close}
            >
                <div id="question-delete-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('gen_confirm_popup_title')}</h2>
                        <p className="uc-modal__desc">
                            {i18n.t('conf_q_del')}
                        </p>
                    </div>
                    {this.renderSkipLogicWarnings()}
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.removeQuestion}
                            cssClass="error"
                            label={i18n.t('gen_yes')}
                        />
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
